import React from "react";
import PropTypes from "prop-types";
import CheckBox from "../CheckBox";
import styles from "./styles.module.scss";

const SelectTable = ({
    title,
    noResults,
    rows,
    selected,
    handleRowSelect,
    handleAllSelect,
    disabled,
    checkIsDisabled,
    styleType,
    error,
}) => {
    const allSelected = rows.length > 0 && rows.length === selected.length;

    let tbody = (
        <tr>
            <td>{noResults}</td>
        </tr>
    );

    if (Array.isArray(rows) && rows.length > 0) {
        tbody = rows.map((row, idx) => {
            const checked = selected.includes(row.id);
            return (
                <tr key={idx}>
                    <td className={styles.id}>{`${idx + 1}`}</td>
                    {row.columns.map((i, idx) => (
                        <td key={idx} className={styles.field}>
                            {i}
                        </td>
                    ))}
                    <td className={styles.checkbox}>
                        <CheckBox
                            ariaLabel={`label-for-${row.name}`}
                            small
                            selected={checked}
                            dataTestId={`select-${row.name}`}
                            onChange={() => handleRowSelect(row, checked)}
                            disabled={
                                checkIsDisabled !== undefined
                                    ? checkIsDisabled(row)
                                    : disabled
                            }
                            styleName="black"
                        />
                    </td>
                </tr>
            );
        });
    }

    let headerSelectClasses = [styles.checkbox, styles.fix];

    return (
        <div
            className={`${styles.table} ${styleType ? styles[styleType] : ""} ${
                error ? styles.error : ""
            }`}
        >
            <table className={styles.sticky}>
                <thead>
                    <tr>
                        <th className={styles.title}>{title}</th>
                        <th
                            className={headerSelectClasses.join(" ")}
                            aria-label="Counterparty"
                        >
                            <CheckBox
                                small
                                dataTestId="select-all"
                                selected={allSelected}
                                onChange={handleAllSelect}
                                disabled={disabled}
                                styleName="black"
                                ariaLabel="counterparty"
                            />
                        </th>
                    </tr>
                </thead>
            </table>
            <div className={styles.scroll}>
                <table>
                    <tbody>{tbody}</tbody>
                </table>
            </div>
        </div>
    );
};

SelectTable.propTypes = {
    title: PropTypes.string.isRequired,
    rows: PropTypes.array.isRequired,
    selected: PropTypes.array.isRequired,
    handleAllSelect: PropTypes.func.isRequired,
    handleRowSelect: PropTypes.func.isRequired,
};

export default SelectTable;
